module.exports = __webpack_public_path__ + "media/images/crowd-enjoyment-wide-72d860dec4f935824f2a40b81ff5f211.png";